import React from 'react';
import LoadingSpinner from './LoadingSpinner';

const SMSModal = ({ 
  isOpen, 
  onClose, 
  loadingDetails, 
  conversationDetails, 
  messages, 
  formatPhoneNumber 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden shadow-xl">
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-900">SMS Conversation</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl p-1"
          >
            ✕
          </button>
        </div>
        
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          {loadingDetails ? (
            <LoadingSpinner message="Loading messages..." />
          ) : conversationDetails ? (
            <div className="space-y-6">
              <div className="bg-gray-50 rounded-xl p-4">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span className="font-medium text-gray-600">Customer:</span>{' '}
                    <span className="text-gray-900">{formatPhoneNumber(conversationDetails.from_number)}</span>
                  </div>
                  <div>
                    <span className="font-medium text-gray-600">Messages:</span>{' '}
                    <span className="text-gray-900">{conversationDetails.turn_count}</span>
                  </div>
                </div>
              </div>
              
              <div>
                <h4 className="font-medium text-gray-900 mb-4">Transcript</h4>
                <div className="space-y-3">
                  {messages
                    .sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0))
                    .map((msg, index) => {
                      const isUser = msg.direction === 'user';
                      
                      return (
                        <div key={index} className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
                          <div className={`max-w-[75%] rounded-2xl px-4 py-3 ${
                            isUser 
                              ? 'bg-blue-400 text-white rounded-br-md' 
                              : 'bg-gray-100 text-gray-900 rounded-bl-md'
                          }`}>
                            <div className="flex items-center gap-2 mb-1">
                              <span className={`text-xs font-medium ${
                                isUser ? 'text-white' : 'text-gray-500'
                              }`}>
                                {isUser ? 'Customer' : 'Assistant'}
                              </span>
                              <span className={`text-xs px-2 py-0.5 rounded-full ${
                                isUser 
                                  ? 'bg-blue-400 text-blue-50' 
                                  : 'bg-purple-100 text-purple-700'
                              }`}>
                                📱 SMS
                              </span>
                              <span className={`text-xs ${
                                isUser ? 'text-white' : 'text-gray-400'
                              }`}>
                                {new Date(msg.timestamp).toLocaleTimeString('en-US', {
                                  hour: 'numeric',
                                  minute: '2-digit',
                                  second: '2-digit'
                                })}
                              </span>
                            </div>
                            <p className={`text-sm leading-relaxed ${
                              isUser ? 'text-white' : 'text-gray-900'
                            }`}>
                              {msg.content}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          ) : (
            <p className="text-gray-600">No messages found in this conversation.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SMSModal;